import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.75 0C3.029 0 0 3.05 0 6.799c0 5.327 6.116 10.828 6.376 11.059a.56.56 0 0 0 .748 0c.26-.232 6.376-5.732 6.376-11.06C13.5 3.05 10.472 0 6.75 0m0 10.5A3.754 3.754 0 0 1 3 6.75 3.754 3.754 0 0 1 6.75 3a3.754 3.754 0 0 1 3.75 3.75 3.754 3.754 0 0 1-3.75 3.75" }, null, -1)
  ])))
}
export default { render: render }